var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[(_vm.loading)?_c('FullLoader'):(_vm.errMessage)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.errMessage)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }